export interface UserListModel {
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    registerDate: string;
    userRole: string;
    isActive: boolean;
}
export class UserDetailModel {
    UserName: string;
    Email: string;
    PasswordHash: string;
    PhoneNumber: string;
    TwoFactorEnabled: boolean;
    FirstName: string;
    LastName: string;
    CreatedBy: string;
    isActive: boolean;
    UserRoles: any[];
    orgaizationID: any;
    databaseID: any;
    offices: any=[];
    myOfficeID:any;
}
export class UpdateUserModel {
    UUID: string;
    PhoneNumber: string;
    FirstName: string;
    LastName: string;
    ModifiedBy: string;
    isActive: boolean;
    UserRoles: any[];
    organizationID:number=0;
    Offices:any=[];
}

export class UpdateUserProfileModel {
    UUID: string;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    Email:string;
    Phone:string;
    Address:string;
    DOB:string;
    Title:string;
    TimeZone:string;
    ModifiedBy: string;
    isActive: boolean;   
    orgaizationID:number=0;
}

export class DeleteUserModel {
    uuid: string;
}
export class GetUserModel {
    uuid: string;
}
export class ExistUserCheckModel {
    Email: string;
}
